var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-button", on: { click: _vm.goToPriceWatcherPage } },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c("div", _vm._g({ staticClass: "home-button__icon" }, on), [
                    _c(
                      "svg",
                      {
                        staticStyle: {
                          "enable-background": "new 0 0 1080 1080",
                        },
                        attrs: {
                          id: "Layer_1",
                          xmlns: "http://www.w3.org/2000/svg",
                          x: "0px",
                          y: "0px",
                          height: "256px",
                          viewBox: "0 0 1080 1080",
                          "xml:space": "preserve",
                        },
                      },
                      [
                        _c("g", [
                          _c("path", {
                            staticClass: "st404",
                            attrs: {
                              d: "M118.1,962.1c1.7,0.1,3.4,0.1,5.2,0.4c2.4,0.1,10.8,0.8,16,6.9c2.2,2.4,5.4,7.6,5.4,16.1\n\t\tc0,1.8-0.1,4.9-1.1,9.1c-0.9,3.4-2.7,10-9.8,15.2c-8.1,5.8-17.1,5.7-20.5,5.7c-3.3,0-6.5-0.3-9.9-0.6l-4.8-15.2\n\t\tc3.5,0.4,7.1,0.8,10.6,0.8c0.7,0,3.7,0,6.1-0.7c5.9-1.7,10.6-6.8,10.6-13c0-1-0.1-3.5-1.4-5.7c-2.4-4-6.4-4.4-15.7-4.1H96.6\n\t\tc-0.9,15.8-1.8,31.7-2.4,47.4c-0.4,9.6-0.7,19.1-0.8,28.6H73c0.6-4.7,1.1-9.5,1.4-14.1c0.6-7.1,0.8-14.1,1.1-21.3\n\t\tc0.6-8.7,1-17.3,1.3-26c0.3-9.9,0.4-19.6,0.7-29.5L118.1,962.1L118.1,962.1z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M199.6,984c5.5,0.4,10.6,0.9,15.1,3.7c2.7,1.6,7.6,6.2,7.6,13.8c0,1-0.1,3.2-1,5.7\n\t\tc-0.9,2.6-3.6,8.8-11.6,12.7c-2.9,1.4-6.8,2.6-10,3.4l18.7,29.7h-21.2c-2-4.2-4-8.2-6.4-12.2c-2.3-4.1-4.7-8.1-7.2-12\n\t\tc-3-4.9-5.9-9.7-8.8-14.4c2.9,0.2,5.7,0.4,8.6,0.4c2.3,0,12.2-0.1,17.1-5.5c2.3-2.6,2.5-5.2,2.5-6.4c0-1.1-0.3-4.2-3.3-6\n\t\tc-1.9-1.2-3.5-1.6-8.5-1.8l-18.8,0.1c-1.1,13.5-2.1,27.1-2.6,40.6c-0.3,5.8-0.4,11.5-0.5,17.3H150c0.9-7.4,1.5-14.8,2-22.3\n\t\tc0.4-5.7,0.6-11.5,0.9-17.3c0.4-6.2,0.7-12.2,0.9-18.3c0.1-3.7,0.1-7.3,0.1-11L199.6,984L199.6,984z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M249.3,983.9c-1,11.7-2,23.5-2.7,35.3c-0.7,11.2-1.3,22.6-1.9,33.8h-19.3c1.3-11.9,2.4-23.7,3.2-35.6\n\t\tc0.6-11.2,0.9-22.3,1.3-33.6L249.3,983.9z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M328.4,996.8c-9.3-1.6-11.9-2.1-21.3-2.6c-10.9,0.3-19.9,1-26.7,8.1c-2.7,2.9-7.3,9-7.3,18.1\n\t\tc0,9.5,5.6,17.1,17.2,20.3c2.9,0.8,5.6,1.2,11.8,1.6c10.9,0,13.6-0.4,23.8-2.7l-3.2,13.5c-5.4,0.6-7.9,1-17.5,1.3\n\t\tc-1.9,0-3.9,0.1-5.9,0.1c-2.5,0-5.4-0.1-10.5-0.6c-6.6-1.2-12-2.1-17.7-5.2c-9.9-5.4-13.3-12.8-14.4-15.9c-1.4-3.9-1.7-8.3-1.9-9.5\n\t\tc0-8.5,0.6-10,1.9-14.5c1.6-4.2,2.7-6.4,3.9-8.2c4.5-7.1,12.6-13.2,22.2-15.9c4.4-1.2,8-1.6,12.6-2.1c10.4-0.4,14.4-0.7,32,1.2\n\t\tL328.4,996.8z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M402,983.7l-0.5,12.4c-7.8-0.4-15.5-0.7-23.4-0.7c-7.6,0-15.3,0.2-23,0.4l-0.7,15.7l40.5-0.3l-0.7,12.5\n\t\tc-7.2-0.2-14.4-0.5-21.5-0.5c-6.4,0-12.6,0.1-18.9,0.3l-1,17.6c8.8,0.1,17.7,0.3,26.4,0.1c6.8-0.2,13.4-0.5,20.2-0.9v12.5h-66.4\n\t\tc0.5-3.9,1-7.6,1.4-11.5c0.5-5.7,0.7-11.5,1-17.1c0.5-7.8,1-15.7,1.3-23.5c0.3-5.7,0.3-11.4,0.4-17.1L402,983.7L402,983.7z",
                            },
                          }),
                          _c("g", [
                            _c("path", {
                              staticClass: "st404",
                              attrs: {
                                d: "M507.8,1008.4l-14.1-43.8h18.4l6.4,22.3l9.1-22.3h18.4c-1.6,3.1-3.3,6.3-4.8,9.4\n\t\t\tc-2.9,5.9-5.5,11.9-8.2,17.8c-2.4,5.4-4.8,10.7-7.3,16.1l10.7,33.8c1.2-3,2.4-6,3.7-8.9c1.6-3.5,3.3-6.9,4.8-10.5\n\t\t\tc3.3-6.9,6.4-13.9,9.7-20.8c3-6.3,5.9-12.7,8.6-18.9c2.5-6,4.8-12,7.2-18h19.9c-4.1,8.1-8,16.2-11.8,24.4\n\t\t\tc-3.4,7.3-6.7,14.8-10.1,22.1c-4,8.9-8.4,17.6-12.4,26.5c-2.7,6.1-5.4,12.4-8,18.7h-25c-1.2-4.2-2.2-8.2-3.4-12.3\n\t\t\tc-1.6-4.8-3.1-9.5-4.7-14.2l-3.5,8.6c-1.3,2.9-2.7,5.6-3.9,8.5c-1.4,3.1-2.6,6.3-3.9,9.4h-24.4c-1.7-6.5-3.5-12.9-5.5-19.3\n\t\t\tc-2.4-7.3-5-14.5-7.3-21.8c-3.8-11.4-7.3-23-11.2-34.4c-1.8-5.4-3.7-10.7-5.5-16.2l20.5,0.1c1.3,5.5,2.5,11,4.1,16.5\n\t\t\tc1.8,6.3,3.8,12.5,5.9,18.8c0.9,2.7,1.7,5.5,2.6,8.2c3.4,10.7,6.8,21.6,10.2,32.4L507.8,1008.4z",
                              },
                            }),
                            _c("path", {
                              staticClass: "st693",
                              attrs: {
                                d: "M635,986.5c2.1,5.2,4.4,10.3,6.8,15.5c3.3,6.8,6.7,13.5,10,20.3c5.4,11.3,10.8,22.6,16.3,33.9h-20.9\n\t\t\tc-2.9-8.7-3.9-12.1-11.5-26.5h-33.8c-3.4,5-6.9,9.8-10.2,14.9c-2.4,3.8-4.7,7.7-6.8,11.5h-19.8l46.3-69.7H635z M607.8,1018.9h23.7\n\t\t\tl-10-21.6L607.8,1018.9z",
                              },
                            }),
                            _c("path", {
                              staticClass: "st693",
                              attrs: {
                                d: "M734.8,986.7c0,2.2,0,4.4-0.1,6.5c-0.1,2-0.4,3.9-0.6,5.9c-4.8-0.2-9.5-0.5-14.2-0.5c-3.2-0.1-6.3,0-9.5,0\n\t\t\tc-0.8,8.7-1.5,17.3-1.9,26c-0.6,10.6-1,21.3-1.3,32l-19.4-0.1c0.9-9.8,1.9-19.8,2.5-29.7c0.6-9.3,1-18.8,1.3-28.1\n\t\t\tc-5.2-0.1-10.3-0.1-15.4,0.1c-2.8,0.1-5.4,0.3-8.2,0.4l0.8-12.4L734.8,986.7z",
                              },
                            }),
                            _c("path", {
                              staticClass: "st693",
                              attrs: {
                                d: "M806.7,999.6c-9.3-1.7-12-2.2-21.4-2.6c-11,0.3-20,1-26.9,8.2c-2.8,2.9-7.3,9-7.3,18.2\n\t\t\tc0,9.5,5.7,17.2,17.3,20.5c2.9,0.8,5.7,1.2,11.8,1.7c11,0,13.7-0.4,24-2.7l-3.2,13.5c-5.4,0.6-7.9,1-17.6,1.3\n\t\t\tc-1.9,0-3.9,0.1-5.9,0.1c-2.5,0-5.4-0.1-10.6-0.6c-6.7-1.2-12.1-2.2-17.8-5.3c-10-5.4-13.4-12.9-14.5-16c-1.4-4-1.8-8.4-1.9-9.5\n\t\t\tc0-8.6,0.6-10,1.9-14.6c1.6-4.2,2.8-6.5,3.9-8.3c4.5-7.2,12.7-13.2,22.3-16c4.4-1.2,8.1-1.6,12.7-2.1c10.5-0.4,14.5-0.7,32.3,1.2\n\t\t\tL806.7,999.6z",
                              },
                            }),
                            _c("path", {
                              staticClass: "st693",
                              attrs: {
                                d: "M834.5,986.5l-2.3,27.9h47.5c0.5-5.5,0.9-10.9,1.1-16.4c0.1-3.9,0.3-7.7,0.4-11.5l19.7,0.1\n\t\t\tc-1.1,12.5-2.3,25.2-3,37.8c-0.6,10.5-0.9,21.2-1.1,31.8h-19.5c0.6-7.3,1.4-14.4,1.6-21.7c0.1-2.7,0.1-5.5,0.3-8.3l-47.4,0.1\n\t\t\tc-0.4,7-0.9,13.9-1,21c-0.1,2.9-0.1,5.9-0.3,8.9h-19.8c1.3-13.2,2.4-26.5,3-39.7c0.5-10,0.8-20.1,0.9-30H834.5z",
                              },
                            }),
                            _c("path", {
                              staticClass: "st693",
                              attrs: {
                                d: "M978,986.5l-0.5,12.4c-7.8-0.4-15.6-0.7-23.6-0.7c-7.7,0-15.4,0.2-23.1,0.4l-0.8,15.8l40.7-0.3l-0.8,12.6\n\t\t\tc-7.2-0.2-14.5-0.5-21.7-0.5c-6.4,0-12.7,0.1-19,0.3l-1,17.7c8.8,0.1,17.8,0.3,26.6,0.1c6.8-0.2,13.5-0.5,20.3-0.9v12.6h-66.8\n\t\t\tc0.5-3.9,1-7.7,1.4-11.5c0.5-5.8,0.8-11.5,1-17.2c0.5-7.9,1-15.8,1.3-23.7c0.3-5.8,0.3-11.4,0.4-17.2H978z",
                              },
                            }),
                            _c("path", {
                              staticClass: "st693",
                              attrs: {
                                d: "M1031.6,986.8c5.5,0.4,10.7,0.9,15.1,3.7c2.8,1.7,7.7,6.2,7.7,13.8c0,1-0.1,3.2-1,5.7\n\t\t\tc-0.9,2.7-3.7,8.9-11.7,12.8c-2.9,1.4-6.8,2.6-10.1,3.5l18.8,29.9H1029c-2-4.2-4-8.3-6.4-12.3c-2.3-4.1-4.8-8.2-7.2-12.1\n\t\t\tc-3-4.9-5.9-9.7-8.8-14.5c2.9,0.2,5.8,0.4,8.7,0.4c2.3,0,12.2-0.1,17.1-5.6c2.3-2.6,2.5-5.3,2.5-6.5c0-1.1-0.3-4.2-3.3-6.1\n\t\t\tc-1.9-1.2-3.5-1.6-8.6-1.8l-18.9,0.1c-1.1,13.6-2.1,27.2-2.6,40.9c-0.3,5.9-0.4,11.6-0.5,17.4h-19.4c0.9-7.5,1.5-14.9,2-22.5\n\t\t\tc0.4-5.8,0.6-11.6,0.9-17.4c0.4-6.2,0.8-12.2,0.9-18.4c0.1-3.7,0.1-7.4,0.1-11H1031.6z",
                              },
                            }),
                          ]),
                        ]),
                        _c("g", [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Device_00000061472743477043613180000013547389155823413408_",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "Monitor_00000063630725263384872250000009783412620832976297_",
                                  },
                                },
                                [
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "XMLID_00000037689484820180144000000012776445398189452703_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "262.6432",
                                        y1: "419",
                                        x2: "757.4606",
                                        y2: "419",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#6B59A6",
                                        },
                                        attrs: { offset: "0" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#7D96AD",
                                        },
                                        attrs: { offset: "0.5631" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#8CC9B2",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      fill: "url(#XMLID_00000037689484820180144000000012776445398189452703_)",
                                    },
                                    attrs: {
                                      id: "XMLID_00000078733643085833727460000015115043492975715506_",
                                      d: "\n\t\t\t\tM270.6,769.2c4.4,2.5,11.8,2.4,16.5-0.3C345.8,735,690.3,536.1,749,502.2c4.7-2.7,8.5-9.3,8.5-14.7V83.3c0-5.4-3.6-11.9-8-14.4\n\t\t\t\tc-4.4-2.5-11.8-2.4-16.5,0.3L271.2,335.8c-4.7,2.7-8.5,9.3-8.5,14.7l0,404.2C262.6,760.2,266.2,766.6,270.6,769.2z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "XMLID_00000144306661987948916920000010909138852342970296_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "278.607",
                                        y1: "423.5967",
                                        x2: "757.4635",
                                        y2: "423.5967",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#6B59A6",
                                        },
                                        attrs: { offset: "0" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#7D96AD",
                                        },
                                        attrs: { offset: "0.5631" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#8CC9B2",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      fill: "url(#XMLID_00000144306661987948916920000010909138852342970296_)",
                                    },
                                    attrs: {
                                      id: "XMLID_00000057137653957608487450000004108798636493404598_",
                                      d: "\n\t\t\t\tM287.1,768.9L749,502.2c4.7-2.7,8.5-9.3,8.5-14.7V83.2c0-5.4-3.8-7.6-8.5-4.9L287.1,345c-4.7,2.7-8.5,9.3-8.5,14.7l0,404.2\n\t\t\t\tC278.6,769.4,282.4,771.6,287.1,768.9z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "XMLID_00000018233157377277033250000016368279973027255681_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "294.5649",
                                        y1: "408.7614",
                                        x2: "741.5064",
                                        y2: "408.7614",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#165A46",
                                        },
                                        attrs: { offset: "0" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#53947E",
                                        },
                                        attrs: { offset: "0.5359" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#8CC9B2",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      fill: "url(#XMLID_00000018233157377277033250000016368279973027255681_)",
                                    },
                                    attrs: {
                                      id: "XMLID_00000036958969269717369510000009648725533562935976_",
                                      d: "\n\t\t\t\tM294.6,710.6l0-345.5c0-3.3,2.3-7.2,5.1-8.8L736.4,104c2.8-1.6,5.1-0.3,5.1,2.9l0,345.6c0,3.3-2.3,7.2-5.1,8.8L299.7,713.5\n\t\t\t\tC296.9,715.1,294.6,713.8,294.6,710.6z",
                                    },
                                  }),
                                  _c("path", {
                                    staticClass: "st697",
                                    attrs: {
                                      id: "XMLID_00000080907154437711255030000013484228551001794239_",
                                      d: "M294.6,710.6l0-345.5\n\t\t\t\tc0-3.3,2.3-7.2,5.1-8.8L736.4,104c2.8-1.6,5.1-0.3,5.1,2.9l0,345.6c0,3.3-2.3,7.2-5.1,8.8L299.7,713.5\n\t\t\t\tC296.9,715.1,294.6,713.8,294.6,710.6z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000162329573743280636550000018178889841458502529_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "511.7806",
                                        y1: "607.9062",
                                        x2: "529.679",
                                        y2: "607.9062",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#165A46",
                                        },
                                        attrs: { offset: "0" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#53947E",
                                        },
                                        attrs: { offset: "0.5359" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#8CC9B2",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      fill: "url(#SVGID_00000162329573743280636550000018178889841458502529_)",
                                    },
                                    attrs: {
                                      d: "M517.2,619.2c-0.9,0-1.8-0.2-2.6-0.7\n\t\t\t\tc-1.8-1-2.8-3.2-2.8-6c0-5.5,3.7-11.9,8.5-14.7l0,0c2.4-1.4,4.8-1.6,6.6-0.6c1.8,1.1,2.8,3.2,2.8,6c0,5.5-3.7,11.9-8.5,14.7\n\t\t\t\tC519.8,618.8,518.4,619.2,517.2,619.2z M524.3,598.6c-0.9,0-2,0.3-3.1,1l0,0c-4.1,2.4-7.5,8.2-7.5,13c0,2.1,0.7,3.6,1.9,4.3\n\t\t\t\tc1.2,0.7,2.9,0.5,4.7-0.6c4.1-2.4,7.5-8.2,7.5-13c0-2.1-0.7-3.6-1.9-4.3C525.4,598.7,524.9,598.6,524.3,598.6z",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Window_00000137122717356888757400000014323077822793007780_",
                              },
                            },
                            [
                              _c("g", [
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st697",
                                    attrs: {
                                      d: "M817.4,169.1L367.6,428.4l0,331.5c0,4.4,4.8,7.2,8.6,5l8-4.6L809,515.4c4.6-2.7,8.4-9.2,8.4-14.5V169.1z",
                                    },
                                  }),
                                  _c("path", {
                                    staticClass: "st662",
                                    attrs: {
                                      d: "M815.4,172.4v328.4c0,4.6-3.4,10.5-7.4,12.8L383.2,758.6l-8,4.6c-0.6,0.3-1.2,0.5-1.9,0.5\n\t\t\t\t\tc-1,0-1.9-0.4-2.7-1.1c-0.7-0.7-1.2-1.7-1.2-2.7l0-330.4L815.4,172.4 M817.4,169.1L367.6,428.4l0,331.5c0,3.3,2.8,5.8,5.8,5.8\n\t\t\t\t\tc1,0,1.9-0.2,2.8-0.8l8-4.6L809,515.4c4.6-2.7,8.4-9.2,8.4-14.5V169.1L817.4,169.1z",
                                    },
                                  }),
                                ]),
                                _c("polygon", {
                                  staticClass: "st699",
                                  attrs: {
                                    points:
                                      "806.7,162.9 356.9,422.3 367.6,428.4 817.4,169.1 \t\t\t",
                                  },
                                }),
                                _c("path", {
                                  staticClass: "st664",
                                  attrs: {
                                    d: "M370.6,765c0,0-3-1.5-3-5.1l0-322c0-2.6,0-9.5,0-9.5l-10.7-6.2l0,329.7c0,0.4,0,0.8,0.1,1.2\n\t\t\t\tc0.4,2.7,2,5.1,4.4,6.5l8.8,5.1L370.6,765L370.6,765z",
                                  },
                                }),
                              ]),
                              _c("g", [
                                _c(
                                  "g",
                                  [
                                    _c(
                                      "linearGradient",
                                      {
                                        attrs: {
                                          id: "SVGID_00000161626713202169307930000008006692510298651579_",
                                          gradientUnits: "userSpaceOnUse",
                                          x1: "356.875",
                                          y1: "282.9086",
                                          x2: "817.3567",
                                          y2: "282.9086",
                                        },
                                      },
                                      [
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#6B59A6",
                                          },
                                          attrs: { offset: "0" },
                                        }),
                                        _c("stop", {
                                          staticStyle: {
                                            "stop-color": "#3E3F6F",
                                          },
                                          attrs: { offset: "1" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("path", {
                                      staticStyle: {
                                        fill: "url(#SVGID_00000161626713202169307930000008006692510298651579_)",
                                      },
                                      attrs: {
                                        d: "M356.9,422.4V400\n\t\t\t\t\tc0-2.7,1.9-5.9,4.2-7.3l441.5-254.5c2.3-1.3,6-1.4,8.4,0l2.3,1.3c2.3,1.3,4.2,4.6,4.2,7.2l0,22.4L367.6,428.6L356.9,422.4z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st701",
                                      attrs: {
                                        d: "M368.8,402.1c-0.8,1.3-1.2,2.8-1.2,4.1v22.4l-10.7-6.2V400c0-1.3,0.5-2.8,1.2-4.1L368.8,402.1z",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("path", {
                                  staticClass: "st702",
                                  attrs: {
                                    d: "M367.6,406.2c0-2.7,1.9-5.9,4.2-7.3l441.4-254.5c2.3-1.3,4.2-0.3,4.2,2.4l0,22.4L367.6,428.6L367.6,406.2z\n\t\t\t\t",
                                  },
                                }),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st406",
                                    attrs: {
                                      d: "M797.7,168.2c0,2.5,1.8,3.5,3.9,2.3c2.2-1.3,3.9-4.3,3.9-6.8c0-2.5-1.8-3.5-3.9-2.3\n\t\t\t\t\tC799.5,162.7,797.7,165.7,797.7,168.2z",
                                    },
                                  }),
                                  _c("path", {
                                    staticClass: "st406",
                                    attrs: {
                                      d: "M782,177.3c0,2.5,1.8,3.5,3.9,2.3c2.2-1.3,3.9-4.3,3.9-6.8c0-2.5-1.8-3.5-3.9-2.3\n\t\t\t\t\tC783.8,171.7,782,174.8,782,177.3z",
                                    },
                                  }),
                                  _c("path", {
                                    staticClass: "st406",
                                    attrs: {
                                      d: "M766.3,186.3c0,2.5,1.8,3.5,3.9,2.3c2.2-1.3,3.9-4.3,3.9-6.8c0-2.5-1.8-3.5-3.9-2.3\n\t\t\t\t\tC768.1,180.8,766.3,183.8,766.3,186.3z",
                                    },
                                  }),
                                ]),
                              ]),
                              _c("g", [
                                _c("path", {
                                  staticClass: "st703",
                                  attrs: {
                                    d: "M367.6,428.6l0,331.4c0,4.4,4.8,7.2,8.6,5l8-4.6l98.3-56.7V362.3L367.6,428.6L367.6,428.6z",
                                  },
                                }),
                                _c("polygon", {
                                  staticClass: "st703",
                                  attrs: {
                                    points:
                                      "490.3,367.9 490.3,689.7 807.9,506.4 807.9,184.5 \t\t\t",
                                  },
                                }),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st704",
                                    attrs: {
                                      d: "M456.2,401.2l-73.3,42.4c-1.4,0.8-2.5,2.7-2.5,4.3l0,7.6c0,1.6,1.1,2.2,2.5,1.4l73.3-42.4\n\t\t\t\t\tc1.4-0.8,2.5-2.7,2.5-4.3l0-7.6C458.6,401.1,457.5,400.4,456.2,401.2z",
                                    },
                                  }),
                                  _c("path", {
                                    staticClass: "st705",
                                    attrs: {
                                      d: "M456.2,401.2l-73.3,42.4c-1.4,0.8-2.5,2.7-2.5,4.3l0,7.6c0,1.6,1.1,2.2,2.5,1.4l73.3-42.4\n\t\t\t\t\tc1.4-0.8,2.5-2.7,2.5-4.3l0-7.6C458.6,401.1,457.5,400.4,456.2,401.2z",
                                    },
                                  }),
                                  _c("path", {
                                    staticClass: "st706",
                                    attrs: {
                                      d: "M472.5,404.2l-2.2-2.1c0.4-1.1,0.7-2.3,0.7-3.5c0-1.8-0.6-3.1-1.6-3.7c-0.8-0.5-1.7-0.4-2.6,0.1\n\t\t\t\t\tc-1.9,1.1-3.4,4.2-3.4,7c0,1.8,0.6,3.1,1.6,3.7c0.4,0.2,0.8,0.3,1.2,0.3c0.5,0,1-0.1,1.5-0.4c0.7-0.4,1.4-1.1,1.9-2l1.8,1.7\n\t\t\t\t\tc0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.3C472.8,405.1,472.8,404.6,472.5,404.2z M466.8,404.2c-0.4,0.2-0.7,0.3-0.9,0.1\n\t\t\t\t\tc-0.4-0.2-0.8-0.9-0.8-2.2c0-2.2,1.2-4.8,2.5-5.5c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.2,0,0.3,0.1c0.4,0.2,0.8,0.9,0.8,2.2\n\t\t\t\t\tC469.3,400.9,468.2,403.4,466.8,404.2z",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("g", [
                                    _c("g", [
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M382.2,479.3l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9\n\t\t\t\t\t\t\t\tc0.1-0.1,0.2,0,0.2,0.1v4.5C382.4,479.1,382.3,479.2,382.2,479.3z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M384.7,477.8l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9\n\t\t\t\t\t\t\t\tc0.1-0.1,0.2,0,0.2,0.1v4.5C384.8,477.6,384.8,477.8,384.7,477.8z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M387.1,476.4l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9\n\t\t\t\t\t\t\t\tc0.1-0.1,0.2,0,0.2,0.1v4.5C387.3,476.2,387.2,476.4,387.1,476.4z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M382.2,485l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9\n\t\t\t\t\t\t\t\tc0.1-0.1,0.2,0,0.2,0.1v4.5C382.4,484.8,382.3,484.9,382.2,485z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M384.7,483.6l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9\n\t\t\t\t\t\t\t\tc0.1-0.1,0.2,0,0.2,0.1v4.5C384.8,483.4,384.8,483.5,384.7,483.6z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M387.1,482.2l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9\n\t\t\t\t\t\t\t\tc0.1-0.1,0.2,0,0.2,0.1v4.5C387.3,481.9,387.2,482.1,387.1,482.2z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M382.5,500.2l-2-1.2c-0.1,0-0.1-0.2,0-0.4l2-3.6c0.1-0.2,0.2-0.1,0.2,0v4.8\n\t\t\t\t\t\t\t\tC382.7,500,382.6,500.2,382.5,500.2z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M381.6,497.4l2.7-1.5v1.3l-2.7,1.5c-0.2,0.1-0.4,0-0.4-0.4C381.2,498,381.4,497.6,381.6,497.4z",
                                          },
                                        }),
                                        _c("polygon", {
                                          staticClass: "st706",
                                          attrs: {
                                            points:
                                              "384.8,495.6 385.7,495.1 385.7,496.4 384.8,496.9 \t\t\t\t\t\t\t",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M388.1,494.3v4.7c0,0.4-0.2,0.7-0.4,0.9c-0.2,0.1-0.4,0-0.4-0.4v-4l-1.1,0.7v-1.3l1.5-0.9\n\t\t\t\t\t\t\t\tC387.9,493.8,388.1,494,388.1,494.3z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M383.2,510.6c-1.9,1.3-3.2,4.9-2.8,7.5c0.3,2.4,1.8,2.3,1.9,3.5c0,0.1,0.1,0.2,0.2,0.1l1.8-1\n\t\t\t\t\t\t\t\tc0.1-0.1,0.2-0.2,0.2-0.3c0.2-1.5,2-3.3,2-6.9C386.6,510.7,385.1,509.3,383.2,510.6z",
                                          },
                                        }),
                                      ]),
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M384.3,523.6l-1.7,1c-0.1,0.1-0.2,0-0.2-0.2v-1.6c0-0.2,0.1-0.3,0.2-0.4l1.7-1c0.1-0.1,0.2,0,0.2,0.2\n\t\t\t\t\t\t\tv1.6C384.5,523.3,384.4,523.5,384.3,523.6z",
                                        },
                                      }),
                                    ]),
                                    _c("path", {
                                      staticClass: "st706",
                                      attrs: {
                                        d: "M383.7,473c-1.6,1.3-2.9,4.1-3.2,6.7c-0.2,1.5,0,2.8,0.5,3.6l-0.6,3c0,0.3,0.1,0.4,0.2,0.2l1.8-1.9\n\t\t\t\t\t\tc0.7,0.2,1.6,0,2.5-0.7c1.6-1.3,2.9-4.1,3.2-6.7C388.5,473,386.3,470.9,383.7,473z M384.3,483c-1.6,0.9-2.9-0.3-2.9-2.8\n\t\t\t\t\t\tc0-2.5,1.3-5.3,2.9-6.2c1.6-0.9,2.9,0.3,2.9,2.8C387.2,479.3,385.9,482,384.3,483z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st706",
                                      attrs: {
                                        d: "M383.7,531.7c-1.6,1.3-2.9,4.1-3.2,6.7c-0.2,1.5,0,2.8,0.5,3.6l-0.6,3c0,0.3,0.1,0.4,0.2,0.2l1.8-1.9\n\t\t\t\t\t\tc0.7,0.2,1.6,0,2.5-0.7c1.6-1.3,2.9-4.1,3.2-6.7C388.5,531.7,386.3,529.5,383.7,531.7z M384.3,541.6c-1.6,0.9-2.9-0.3-2.9-2.8\n\t\t\t\t\t\tc0-2.5,1.3-5.3,2.9-6.2s2.9,0.3,2.9,2.8C387.2,537.9,385.9,540.7,384.3,541.6z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M386.1,553.2c0,1.3-0.7,2.8-1.5,3.3c-0.9,0.5-1.5-0.2-1.5-1.5s0.7-2.8,1.5-3.3\n\t\t\t\t\t\t\tC385.5,551.2,386.1,551.8,386.1,553.2z",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M388.8,553.6c0,0.9-0.5,1.8-1,2.2c-0.6,0.3-1-0.1-1-1c0-0.9,0.5-1.8,1-2.2\n\t\t\t\t\t\t\tC388.3,552.3,388.8,552.8,388.8,553.6z",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M386.4,562.5l-3.6,2.1V560c0-1,0.6-2.1,1.3-2.5l1-0.6c0.7-0.4,1.3,0,1.3,1V562.5z",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M387.9,556.3l-1,0.6v5.3l1.9-1.1V557C388.8,556.4,388.4,556.1,387.9,556.3z",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M380.4,558.5c0,0.9,0.5,1.3,1,1c0.6-0.3,1-1.3,1-2.2c0-0.9-0.5-1.3-1-1\n\t\t\t\t\t\t\tC380.9,556.6,380.4,557.6,380.4,558.5z",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M381.3,560.2l1-0.6v5.3l-1.9,1.1v-4.1C380.4,561.2,380.8,560.5,381.3,560.2z",
                                        },
                                      }),
                                    ]),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M398.2,468.8l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C396.1,471,397.1,469.5,398.2,468.8z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M398.2,489l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C396.1,491.3,397.1,489.7,398.2,489z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M398.2,509.2l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C396.1,511.5,397.1,509.9,398.2,509.2z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M398.2,529.4l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5L398.2,534\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C396.1,531.7,397.1,530.1,398.2,529.4z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M398.2,549.6l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C396.1,551.9,397.1,550.3,398.2,549.6z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st706",
                                      attrs: {
                                        d: "M406.1,566.1l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1S404.9,566.8,406.1,566.1z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M406.1,579.8L449,555c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C404,582,404.9,580.5,406.1,579.8z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M406.1,593.4l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5L406.1,598\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C404,595.7,404.9,594.1,406.1,593.4z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M414.4,602.1l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1S413.3,602.8,414.4,602.1z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M404.4,613.9l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3\n\t\t\t\t\t\t\tC404,614.1,404.2,614.1,404.4,613.9z",
                                        },
                                      }),
                                    ]),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M414.4,615.7l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1S413.3,616.4,414.4,615.7z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M404.4,627.5l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3\n\t\t\t\t\t\t\tC404,627.7,404.2,627.7,404.4,627.5z",
                                        },
                                      }),
                                    ]),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M414.4,629.3l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C412.3,631.5,413.3,630,414.4,629.3z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M404.4,641.1l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3\n\t\t\t\t\t\t\tC404,641.3,404.2,641.3,404.4,641.1z",
                                        },
                                      }),
                                    ]),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M414.4,642.9l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C412.3,645.1,413.3,643.6,414.4,642.9z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M404.4,654.7l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3\n\t\t\t\t\t\t\tC404,654.9,404.2,654.9,404.4,654.7z",
                                        },
                                      }),
                                    ]),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M414.4,656.5l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5L414.4,661\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C412.3,658.7,413.3,657.2,414.4,656.5z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M404.4,668.3l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3\n\t\t\t\t\t\t\tC404,668.5,404.2,668.5,404.4,668.3z",
                                        },
                                      }),
                                    ]),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M414.4,670.1l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C412.3,672.3,413.3,670.8,414.4,670.1z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M404.4,681.9l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3\n\t\t\t\t\t\t\tC404,682.1,404.2,682.1,404.4,681.9z",
                                        },
                                      }),
                                    ]),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M414.4,683.7l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C412.3,685.9,413.3,684.4,414.4,683.7z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M404.4,695.5l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3\n\t\t\t\t\t\t\tC404,695.7,404.2,695.7,404.4,695.5z",
                                        },
                                      }),
                                    ]),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M414.4,697.3l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C412.3,699.5,413.3,698,414.4,697.3z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M404.4,709.1l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3\n\t\t\t\t\t\t\tC404,709.3,404.2,709.3,404.4,709.1z",
                                        },
                                      }),
                                    ]),
                                  ]),
                                ]),
                                _c("g", [
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st697",
                                      attrs: {
                                        d: "M500.3,412l141.1-81.4c1.2-0.7,2.1-2.3,2.1-3.6v-36c0-1.3-0.9-1.9-2.1-1.2l-141.1,81.4\n\t\t\t\t\t\tc-1.2,0.7-2.1,2.3-2.1,3.6v36C498.2,412.2,499.1,412.7,500.3,412z",
                                      },
                                    }),
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "XMLID_00000072968645905946564020000007817186222589034166_",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "XMLID_00000167373217720417247470000010158439763454396568_",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                d: "M512.6,386.7C512.6,386.6,512.6,386.6,512.6,386.7l0.9-3.9l-1.3,0.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1\n\t\t\t\t\t\t\t\tv-0.7c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1l2-1.2c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v0.6c0,0.1,0,0.2-0.1,0.4l-0.9,3.9\n\t\t\t\t\t\t\t\tc0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1l-0.6,0.3C512.7,386.8,512.6,386.8,512.6,386.7C512.6,386.7,512.6,386.7,512.6,386.7z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                d: "M516,380.2c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4\n\t\t\t\t\t\t\t\tc0.1,0.2,0.1,0.4,0.1,0.6c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.6c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.1,0.5-0.2,0.7\n\t\t\t\t\t\t\t\tc-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.2-0.3,0.3-0.6,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.3-0.1-0.4-0.2\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.2-0.3-0.2-0.4c0-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0.1-0.7\n\t\t\t\t\t\t\t\tc0-0.2,0.1-0.5,0.2-0.7c0.1-0.2,0.2-0.4,0.4-0.6C515.6,380.4,515.8,380.3,516,380.2z M516.5,382.8c0-0.4,0-0.8,0-1.1\n\t\t\t\t\t\t\t\tc0-0.1,0-0.2,0-0.3c0-0.1,0-0.2-0.1-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.2,0.2\n\t\t\t\t\t\t\t\tc-0.1,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.4,0,0.7,0,1.1c0,0.1,0,0.2,0,0.3\n\t\t\t\t\t\t\t\tc0,0.1,0,0.2,0.1,0.2c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.2\n\t\t\t\t\t\t\t\tc0-0.1,0.1-0.2,0.1-0.3C516.4,383,516.5,382.9,516.5,382.8z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                d: "M519,379.4c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3\n\t\t\t\t\t\t\t\tc-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.3\n\t\t\t\t\t\t\t\tc0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3\n\t\t\t\t\t\t\t\tc0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2\n\t\t\t\t\t\t\t\tC518.9,379.2,519,379.3,519,379.4z M520,378c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l0.4-0.2c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1\n\t\t\t\t\t\t\t\tc0,0,0,0,0,0c0,0,0,0,0,0l-2.1,5.5c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1l-0.4,0.2c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1\n\t\t\t\t\t\t\t\tc0,0,0,0,0,0c0,0,0,0,0,0L520,378z M518.1,380.4c0,0.1,0,0.2,0,0.2c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3\n\t\t\t\t\t\t\t\tc0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0,0.3\n\t\t\t\t\t\t\t\tC518.1,380.1,518.1,380.2,518.1,380.4z M521,380.6c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.3-0.1,0.4\n\t\t\t\t\t\t\t\tc-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4\n\t\t\t\t\t\t\t\tc0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0.1\n\t\t\t\t\t\t\t\tc0.1,0.1,0.1,0.1,0.1,0.2C520.9,380.3,521,380.5,521,380.6z M520.1,381.5c0,0.1,0,0.2,0,0.2c0,0,0.1,0,0.1,0\n\t\t\t\t\t\t\t\tc0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3c0-0.2,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2\n\t\t\t\t\t\t\t\tc0,0.1,0,0.2,0,0.3C520.1,381.3,520.1,381.4,520.1,381.5z",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "XMLID_00000044868265778579349310000012006288693181377448_",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                id: "XMLID_00000120531237328809010610000015923951295657917068_",
                                                d: "M512.6,375.6l-1.4-2.2\n\t\t\t\t\t\t\t\tc-1.6,2.6-2.7,5.8-3.3,9l2.3-0.2C510.5,379.9,511.4,377.5,512.6,375.6z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                id: "XMLID_00000016074778353802237890000003606302221663189392_",
                                                d: "M516.6,371.3v-3.7\n\t\t\t\t\t\t\t\tc-2,1.2-3.9,3.3-5.4,5.8l1.4,2.2C513.7,373.7,515.1,372.1,516.6,371.3z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                id: "XMLID_00000151503114317933288900000006835987728718290072_",
                                                d: "M509.7,385.7c0-1.1,0.1-2.3,0.3-3.4\n\t\t\t\t\t\t\t\tl-2.3,0.2c-0.3,1.5-0.5,3.1-0.5,4.6c0,1.5,0.2,2.9,0.5,4.1l2.3-2.5C509.9,387.8,509.7,386.8,509.7,385.7z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st704",
                                              attrs: {
                                                id: "XMLID_00000002384337300152688120000011131918148307720886_",
                                                d: "M525.3,372.3\n\t\t\t\t\t\t\t\tc-0.6-2.5-1.8-4.3-3.3-5.2c-1.5-0.8-3.4-0.8-5.4,0.4v3.7c1.5-0.9,2.9-0.9,4-0.3c1.1,0.6,2,1.9,2.5,3.8c0.2,0.9,0.3,1.9,0.3,3\n\t\t\t\t\t\t\t\tc0,1.1-0.1,2.3-0.3,3.4c-0.4,2.4-1.3,4.7-2.5,6.7c-1.1,1.9-2.5,3.5-4,4.3c-1.5,0.9-2.9,0.9-4,0.3c-1.1-0.6-2-1.9-2.5-3.8\n\t\t\t\t\t\t\t\tl-2.3,2.5c0.6,2.5,1.8,4.3,3.3,5.2c1.5,0.8,3.4,0.8,5.4-0.4c2-1.2,3.9-3.3,5.4-5.8c1.6-2.6,2.7-5.8,3.3-9\n\t\t\t\t\t\t\t\tc0.3-1.5,0.5-3.1,0.5-4.6S525.6,373.5,525.3,372.3z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("path", {
                                      staticClass: "st706",
                                      attrs: {
                                        d: "M539.5,362.2l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C537.4,364.4,538.4,362.8,539.5,362.2z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M539.5,371.3l74.3-42.9c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-74.3,42.9\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C537.4,373.5,538.4,372,539.5,371.3z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st697",
                                      attrs: {
                                        d: "M653.4,323.6l141.1-81.4c1.2-0.7,2.1-2.3,2.1-3.6v-36c0-1.3-0.9-1.9-2.1-1.2l-141.1,81.4\n\t\t\t\t\t\tc-1.2,0.7-2.1,2.3-2.1,3.6v36C651.3,323.8,652.2,324.3,653.4,323.6z",
                                      },
                                    }),
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "XMLID_00000145050468498538114450000015982460216364749464_",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "XMLID_00000008138133886428888500000009542734875860885172_",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                d: "M666.4,295c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.3-0.4,0.4-0.6\n\t\t\t\t\t\t\t\tc0.2-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.3-0.1,0.5-0.2c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.2,0.1,0.4,0.1,0.6\n\t\t\t\t\t\t\t\tc0,0.1,0,0.3,0,0.4c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3l-0.8,2.2c0,0,0,0.1,0,0.1\n\t\t\t\t\t\t\t\tc0,0,0,0.1-0.1,0.1l-0.7,0.4c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0l0.5-1.5c-0.1,0.1-0.3,0.1-0.4,0.1\n\t\t\t\t\t\t\t\tc-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.4C666.4,295.4,666.4,295.2,666.4,295z M668.1,294c0-0.1,0-0.2,0-0.2\n\t\t\t\t\t\t\t\tc0-0.1-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2\n\t\t\t\t\t\t\t\tc0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1\n\t\t\t\t\t\t\t\tc0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2C668.1,294.2,668.1,294.1,668.1,294z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                d: "M670.5,290.9c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4\n\t\t\t\t\t\t\t\tc0,0.2,0.1,0.4,0.1,0.6c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.6c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.1,0.5-0.2,0.7\n\t\t\t\t\t\t\t\tc-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.2-0.3,0.3-0.6,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.3-0.1-0.4-0.2\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.2-0.3-0.2-0.4c0-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0.1-0.7\n\t\t\t\t\t\t\t\tc0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.2,0.2-0.4,0.4-0.6C670.1,291.2,670.3,291.1,670.5,290.9z M670.9,293.6c0-0.4,0-0.8,0-1.1\n\t\t\t\t\t\t\t\tc0-0.1,0-0.2,0-0.3c0-0.1,0-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.2,0.1-0.2,0.2\n\t\t\t\t\t\t\t\tc-0.1,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.4,0,0.7,0,1.1c0,0.1,0,0.2,0,0.3\n\t\t\t\t\t\t\t\tc0,0.1,0,0.2,0.1,0.2c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.2\n\t\t\t\t\t\t\t\tc0-0.1,0.1-0.2,0.1-0.3C670.9,293.8,670.9,293.7,670.9,293.6z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                d: "M673.4,290.2c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3\n\t\t\t\t\t\t\t\tc-0.1,0.1-0.2,0.2-0.3,0.2s-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.3\n\t\t\t\t\t\t\t\tc0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3\n\t\t\t\t\t\t\t\tc0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2\n\t\t\t\t\t\t\t\tC673.4,290,673.4,290.1,673.4,290.2z M674.5,288.8c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l0.4-0.2c0,0,0.1,0,0.1,0\n\t\t\t\t\t\t\t\tc0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0l-2.1,5.5c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1l-0.4,0.2c0,0-0.1,0-0.1,0\n\t\t\t\t\t\t\t\tc0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0L674.5,288.8z M672.6,291.2c0,0.1,0,0.2,0,0.2c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.1-0.2\n\t\t\t\t\t\t\t\tc0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0,0.3\n\t\t\t\t\t\t\t\tC672.6,290.9,672.6,291,672.6,291.2z M675.4,291.4c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.3-0.1,0.4\n\t\t\t\t\t\t\t\tc-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4\n\t\t\t\t\t\t\t\tc0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0.1\n\t\t\t\t\t\t\t\tc0.1,0.1,0.1,0.1,0.1,0.2C675.4,291.1,675.4,291.2,675.4,291.4z M674.6,292.3c0,0.1,0,0.2,0,0.2c0,0,0.1,0,0.1,0\n\t\t\t\t\t\t\t\tc0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2\n\t\t\t\t\t\t\t\tc0,0.1,0,0.2,0,0.3C674.6,292,674.6,292.2,674.6,292.3z",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "XMLID_00000145017323626838607870000017359005799494442375_",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              staticClass: "st706",
                                              attrs: {
                                                id: "XMLID_00000075121219289113956370000010561945007297178294_",
                                                d: "M670.9,282.1v-3.7\n\t\t\t\t\t\t\t\tc-2,1.2-3.9,3.3-5.4,5.8l1.4,2.2C668,284.5,669.4,283,670.9,282.1z",
                                              },
                                            }),
                                            _c("path", {
                                              staticClass: "st704",
                                              attrs: {
                                                id: "XMLID_00000143586822855497195390000013960178667247713444_",
                                                d: "M679.7,283.2\n\t\t\t\t\t\t\t\tc-0.6-2.5-1.8-4.3-3.3-5.2c-1.5-0.8-3.4-0.8-5.4,0.4v3.7c1.5-0.9,2.9-0.9,4-0.3c1.1,0.6,2,1.9,2.5,3.8c0.2,0.9,0.3,1.9,0.3,3\n\t\t\t\t\t\t\t\tc0,1.1-0.1,2.3-0.3,3.4c-0.4,2.4-1.3,4.7-2.5,6.7c-1.1,1.9-2.5,3.5-4,4.3c-1.5,0.9-2.9,0.9-4,0.3c-1.1-0.6-2-1.9-2.5-3.8\n\t\t\t\t\t\t\t\tc-0.2-0.9-0.3-1.9-0.3-3c0-1.1,0.1-2.3,0.3-3.4c0.4-2.4,1.3-4.7,2.5-6.7l-1.4-2.2c-1.6,2.6-2.7,5.8-3.3,9\n\t\t\t\t\t\t\t\tc-0.3,1.5-0.5,3.1-0.5,4.6s0.2,2.9,0.5,4.1c0.6,2.5,1.8,4.3,3.3,5.2c1.5,0.8,3.4,0.8,5.4-0.4c2-1.2,3.9-3.3,5.4-5.8l0,0l0,0\n\t\t\t\t\t\t\t\tc1.6-2.6,2.7-5.8,3.3-9c0.3-1.5,0.5-3.1,0.5-4.6S680,284.4,679.7,283.2z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("path", {
                                      staticClass: "st706",
                                      attrs: {
                                        d: "M693.9,273l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1s-0.9,2.8-2.1,3.5l-42.9,24.8c-1.2,0.7-2.1,0.2-2.1-1.1\n\t\t\t\t\t\tC691.8,275.2,692.7,273.7,693.9,273z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M693.9,282.2l74.3-42.9c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-74.3,42.9\n\t\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C691.8,284.4,692.7,282.8,693.9,282.2z",
                                      },
                                    }),
                                  ]),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st706",
                                    attrs: {
                                      d: "M514.6,421.9l30.1-17.4c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-30.1,17.4\n\t\t\t\t\tc-1.2,0.7-2.1,0.2-2.1-1.1C512.6,424.1,513.5,422.6,514.6,421.9z",
                                    },
                                  }),
                                  _c("path", {
                                    staticClass: "st662",
                                    attrs: {
                                      d: "M795.5,271L795.5,271L795.5,271 M794.6,271.5l0,229.9c0,0.6-0.6,1.6-1.1,2L500.1,672.8l0-229.9\n\t\t\t\t\tc0-0.6,0.6-1.6,1.1-2l3.7-2.1c1.7-1,3.1-3.3,3.1-5.3v-13.3c0-0.6,0.6-1.6,1.1-2l42.1-24.3v12.4c0,2.2,1.6,3.4,3.1,3.4\n\t\t\t\t\tc0.6,0,1.3-0.2,1.9-0.5L794.6,271.5 M552.1,393.4L552.1,393.4L552.1,393.4 M795.4,269.1c-0.3,0-0.6,0.1-0.9,0.3L555.2,407.5\n\t\t\t\t\tc-0.3,0.2-0.7,0.3-0.9,0.3c-0.7,0-1.2-0.5-1.2-1.5V393c0-0.9-0.5-1.5-1.2-1.5c-0.3,0-0.6,0.1-0.9,0.3l-42.9,24.8\n\t\t\t\t\tc-1.2,0.7-2.1,2.3-2.1,3.6v13.3c0,1.3-0.9,3-2.1,3.6l-3.7,2.1c-1.2,0.7-2.1,2.3-2.1,3.6l0,230.9c0,0.9,0.5,1.5,1.2,1.5\n\t\t\t\t\tc0.3,0,0.6-0.1,0.9-0.3l294.2-169.8c1.2-0.7,2.1-2.3,2.1-3.6l0-230.9C796.5,269.7,796.1,269.1,795.4,269.1L795.4,269.1z",
                                    },
                                  }),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M517.1,452.9c-0.4,0-0.7-0.1-1-0.3c-0.7-0.4-1.1-1.2-1.1-2.2v-8.8c0-1.7,1.1-3.6,2.6-4.5l23.3-13.5\n\t\t\t\t\t\tc0.9-0.5,1.7-0.5,2.4-0.1c0.7,0.4,1.1,1.2,1.1,2.2v8.8c0,1.7-1.1,3.6-2.6,4.5l-23.3,13.5C518,452.7,517.6,452.9,517.1,452.9z\n\t\t\t\t\t\t M518.5,438.9c-0.9,0.5-1.6,1.8-1.6,2.8v8.8c0,0.3,0.1,0.5,0.1,0.5c0,0,0.2,0,0.5-0.1l23.3-13.5c0.9-0.5,1.6-1.8,1.6-2.8v-8.8\n\t\t\t\t\t\tc0-0.3-0.1-0.5-0.1-0.5c0,0-0.2,0-0.5,0.1L518.5,438.9z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M519.9,442.5l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-15.2,8.8c-0.8,0.4-1.4,0.1-1.4-0.7\n\t\t\t\t\t\tC518.5,444,519.1,442.9,519.9,442.5z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st706",
                                        attrs: {
                                          d: "M538.6,432.2l1.3,1.8c0,0.1,0.1,0,0.2-0.1l1.3-3.2c0.1-0.2,0-0.3-0.1-0.2l-2.5,1.5\n\t\t\t\t\t\t\tC538.6,431.9,538.6,432.1,538.6,432.2z",
                                        },
                                      }),
                                    ]),
                                  ]),
                                  _c("g", [
                                    _c("g", [
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M513.9,537.8c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S512.8,538.5,513.9,537.8z\n\t\t\t\t\t\t\t\t",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M529.6,519.7c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5s-2,0.1-2-1.2S528.5,520.3,529.6,519.7z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M545.3,510.6c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5s-2,0.1-2-1.2C543.3,512.8,544.2,511.3,545.3,510.6z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M561,505.5c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S559.9,506.2,561,505.5z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M576.7,489.2c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S575.6,489.9,576.7,489.2z\n\t\t\t\t\t\t\t\t",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M592.4,483.4c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC590.4,485.6,591.3,484.1,592.4,483.4z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M608.1,465.3c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC606.1,467.5,607,465.9,608.1,465.3z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M623.8,460.8c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S622.7,461.4,623.8,460.8z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M639.5,410.9c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC637.5,413.1,638.4,411.6,639.5,410.9z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M655.2,438.1c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC653.2,440.3,654.1,438.7,655.2,438.1z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M670.9,438.1c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC668.9,440.3,669.8,438.7,670.9,438.1z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M686.6,438.1c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC684.6,440.3,685.5,438.7,686.6,438.1z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M702.3,410.9c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC700.3,413.1,701.2,411.6,702.3,410.9z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M718,405.7c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S716.9,406.3,718,405.7z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M733.8,383.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC731.8,385.9,732.7,384.4,733.8,383.7z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M749.4,383.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC747.4,385.9,748.3,384.4,749.4,383.7z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M765.1,383.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC763.1,385.9,764,384.4,765.1,383.7z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M780.8,374.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC778.8,376.9,779.7,375.3,780.8,374.6z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st704",
                                        attrs: {
                                          d: "M513.8,540.7c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l15.9-18.2c0,0,0.1-0.1,0.1-0.1l15.6-9\n\t\t\t\t\t\t\tl15.7-5.1l15.6-16.2c0.1-0.1,0.1-0.1,0.2-0.1l15.6-5.7l15.6-18c0.1-0.1,0.1-0.1,0.2-0.1l15.5-4.5l15.6-49.6\n\t\t\t\t\t\t\tc0.1-0.2,0.2-0.3,0.4-0.3c0.2,0,0.4,0.1,0.5,0.2l15.6,27l15.5,0l15.4,0l15.6-27c0.1-0.1,0.2-0.2,0.3-0.2l15.6-5.2l15.6-21.9\n\t\t\t\t\t\t\tc0.1-0.1,0.2-0.2,0.4-0.2l31.3,0l15.6-9c0.2-0.1,0.5-0.1,0.7,0.2c0.1,0.2,0.1,0.5-0.2,0.7l-15.7,9.1c-0.1,0-0.2,0.1-0.2,0.1\n\t\t\t\t\t\t\tl-31.2,0l-15.6,21.8c-0.1,0.1-0.1,0.1-0.2,0.2l-15.5,5.2l-15.6,27c-0.1,0.1-0.2,0.2-0.4,0.2l0,0l-15.7,0l-15.7,0l0,0\n\t\t\t\t\t\t\tc-0.2,0-0.3-0.1-0.4-0.2l-15.2-26.2l-15.4,48.8c0,0.2-0.2,0.3-0.3,0.3l-15.6,4.5l-15.6,18c-0.1,0.1-0.1,0.1-0.2,0.1L577,492\n\t\t\t\t\t\t\tl-15.6,16.2c-0.1,0.1-0.1,0.1-0.2,0.1l-15.7,5.1l-15.4,8.9l-15.8,18.2C514.1,540.6,514,540.7,513.8,540.7z",
                                        },
                                      }),
                                    ]),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st662",
                                      attrs: {
                                        d: "M513.9,550.2c-0.3,0-0.7-0.2-0.8-0.5c-0.3-0.5-0.1-1.1,0.4-1.3l266.9-154.1c0.5-0.3,1.1-0.1,1.3,0.4\n\t\t\t\t\t\tc0.3,0.5,0.1,1.1-0.4,1.3L514.4,550.1C514.2,550.1,514.1,550.2,513.9,550.2z",
                                      },
                                    }),
                                    _c("g", [
                                      _c("g", [
                                        _c("g", [
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M513.9,528.8c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S512.8,529.4,513.9,528.8z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M529.6,501.6c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC527.6,503.8,528.5,502.2,529.6,501.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M545.3,498.2c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC543.3,500.4,544.2,498.8,545.3,498.2z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M561,465.3c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC559,467.5,559.9,465.9,561,465.3z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M576.7,474.4c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC574.7,476.6,575.6,475,576.7,474.4z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M592.4,469.8c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tS591.3,470.5,592.4,469.8z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M608.1,456.2c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S607,456.9,608.1,456.2z\n\t\t\t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M623.8,438.1c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC621.8,440.3,622.7,438.7,623.8,438.1z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M639.5,433.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC637.5,435.8,638.4,434.2,639.5,433.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M655.2,420c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC653.2,422.2,654.1,420.6,655.2,420z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M670.9,420c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC668.9,422.2,669.8,420.6,670.9,420z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M686.6,383.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC684.6,385.9,685.5,384.4,686.6,383.7z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M702.3,401.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC700.3,403.9,701.2,402.4,702.3,401.7z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M718,383.7c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S716.9,384.4,718,383.7z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M733.7,374.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC731.7,376.9,732.6,375.3,733.7,374.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M749.4,374.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tC747.4,376.9,748.3,375.3,749.4,374.6z",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M765.1,365.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S764,366.2,765.1,365.6z\n\t\t\t\t\t\t\t\t\t\t",
                                              },
                                            }),
                                          ]),
                                          _c("g", [
                                            _c("path", {
                                              staticClass: "st702",
                                              attrs: {
                                                d: "M780.8,365.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\t\t\tS779.7,366.2,780.8,365.6z",
                                              },
                                            }),
                                          ]),
                                        ]),
                                        _c("g", [
                                          _c("path", {
                                            staticClass: "st702",
                                            attrs: {
                                              d: "M513.9,531.6c-0.1,0-0.2,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.7l15.8-27.3c0.1-0.1,0.2-0.2,0.3-0.2\n\t\t\t\t\t\t\t\t\tl15.4-3.3l15.6-32.7c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.3,0,0.4,0l15.5,9l15.4-4.5l15.6-13.5l15.7-18.1\n\t\t\t\t\t\t\t\t\tc0.1-0.1,0.1-0.1,0.2-0.1l15.6-4.5l15.6-13.5c0.1-0.1,0.2-0.1,0.3-0.1h15.4l15.6-36c0.1-0.2,0.2-0.3,0.4-0.3\n\t\t\t\t\t\t\t\t\tc0.2,0,0.3,0,0.4,0.2l15.3,17.7l15.3-17.7c0,0,0.1-0.1,0.1-0.1l15.8-9.1c0.1,0,0.2-0.1,0.2-0.1h15.6l15.5-9\n\t\t\t\t\t\t\t\t\tc0.1,0,0.2-0.1,0.2-0.1h15.7c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-15.6l-15.5,9c-0.1,0-0.2,0.1-0.2,0.1h-15.6l-15.6,9\n\t\t\t\t\t\t\t\t\tl-15.6,18.1c-0.2,0.2-0.5,0.2-0.7,0l-15.2-17.6l-15.4,35.6c-0.1,0.2-0.3,0.3-0.4,0.3h-15.5l-15.6,13.5\n\t\t\t\t\t\t\t\t\tc-0.1,0-0.1,0.1-0.2,0.1l-15.6,4.5l-15.6,18l-15.7,13.6c-0.1,0-0.1,0.1-0.2,0.1l-15.7,4.5c-0.1,0-0.3,0-0.4,0l-15.3-8.8\n\t\t\t\t\t\t\t\t\tl-15.5,32.4c-0.1,0.1-0.2,0.2-0.3,0.3l-15.4,3.3l-15.7,27.1C514.2,531.5,514.1,531.6,513.9,531.6z",
                                            },
                                          }),
                                        ]),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M522.1,461.5l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-15.2,8.8c-0.8,0.4-1.4,0.1-1.4-0.7\n\t\t\t\t\t\t\tC520.7,463,521.3,461.9,522.1,461.5z",
                                        },
                                      }),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M513.9,465.3c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC511.9,467.5,512.8,465.9,513.9,465.3z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st707",
                                          attrs: {
                                            d: "M513.9,465.3c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2\n\t\t\t\t\t\t\t\tC511.9,467.5,512.8,465.9,513.9,465.3z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M522.1,470.5l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8\n\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C520.7,472,521.3,471,522.1,470.5z",
                                        },
                                      }),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M513.9,474.4c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S512.8,475,513.9,474.4z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]),
                                  _c("g", [
                                    _c("g", [
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st702",
                                          attrs: {
                                            d: "M513.9,595.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l8-8.2l7.8-1l7.9-10.2l7.9,1.1l7.7-6.9\n\t\t\t\t\t\t\t\tl7.8-4.7l8-11.1l7.9,2.5l7.6-6.8c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-8,7.2l-7.8-2.4l-7.8,10.7l-7.9,4.7l-7.9,7.2\n\t\t\t\t\t\t\t\tl-7.8-1.1l-7.8,10.1l-7.9,1l-7.7,7.9C514.1,595.1,514,595.2,513.9,595.2z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M517,568.7c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.1c0.4-0.2,0.8-0.4,1.2-0.4\n\t\t\t\t\t\t\t\tc0.4,0,0.7,0.1,0.9,0.4c0.3,0.2,0.5,0.6,0.6,1c0.1,0.4,0.2,1,0.2,1.6c0,0.6-0.1,1.2-0.2,1.8c-0.1,0.6-0.4,1.2-0.6,1.7\n\t\t\t\t\t\t\t\tc-0.3,0.5-0.6,1-0.9,1.4c-0.4,0.4-0.8,0.8-1.2,1c-0.4,0.2-0.8,0.4-1.2,0.4c-0.4,0-0.7-0.1-0.9-0.4c-0.3-0.2-0.5-0.6-0.6-1\n\t\t\t\t\t\t\t\tc-0.1-0.4-0.2-0.9-0.2-1.6c0-0.3,0-0.7,0.1-1c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.2-0.6,0.3-0.8\n\t\t\t\t\t\t\t\tl2.1-5.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2\n\t\t\t\t\t\t\t\tc0,0,0,0.1,0,0.1L517,568.7z M515.5,573.7c0,0.4,0,0.7,0.1,0.9c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.2,0.4,0.2,0.6,0.3\n\t\t\t\t\t\t\t\tc0.2,0,0.5-0.1,0.8-0.2c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.3-0.7,0.4-1.1c0.1-0.4,0.1-0.7,0.1-1.1\n\t\t\t\t\t\t\t\tc0-0.4,0-0.7-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.6c-0.2-0.2-0.4-0.2-0.6-0.2c-0.2,0-0.5,0.1-0.8,0.2s-0.6,0.4-0.8,0.7\n\t\t\t\t\t\t\t\tc-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.3-0.3,0.7-0.4,1.1C515.6,573,515.5,573.3,515.5,573.7z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M522.3,570.8c0,0.2,0.1,0.3,0.2,0.5c0.1,0.2,0.2,0.3,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0\n\t\t\t\t\t\t\t\tc0.2,0,0.5-0.2,0.9-0.4c0.2-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.1-0.7,0.1-1.1\n\t\t\t\t\t\t\t\tc0-0.4,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.4-0.4c-0.2-0.1-0.3-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.7,0.3l-1,0.6c-0.1,0-0.2,0-0.2,0\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3l2.1-4.6l-3.3,1.9c-0.1,0-0.2,0-0.2,0\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3l4.5-2.6c0.1,0,0.2,0,0.2,0\n\t\t\t\t\t\t\t\tc0.1,0.1,0.1,0.2,0.1,0.3v0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.4l-2,4.6c0.4-0.2,0.7-0.3,1.1-0.3\n\t\t\t\t\t\t\t\tc0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.4,0.2,0.8,0.2,1.4c0,0.6-0.1,1.2-0.2,1.8c-0.2,0.6-0.4,1.1-0.6,1.6\n\t\t\t\t\t\t\t\tc-0.3,0.5-0.6,0.9-0.9,1.3c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.3-1,0.5-1.3,0.5c-0.4,0-0.7,0-0.9-0.2c-0.2-0.2-0.4-0.4-0.5-0.7\n\t\t\t\t\t\t\t\tc-0.1-0.3-0.2-0.6-0.2-1c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.2l0.5-0.3c0.1,0,0.2,0,0.2,0\n\t\t\t\t\t\t\t\tC522.3,570.7,522.3,570.8,522.3,570.8z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M529.2,566.9c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.3,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0\n\t\t\t\t\t\t\t\tc0.2,0,0.5-0.2,0.9-0.4c0.2-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.1-0.7,0.1-1.1\n\t\t\t\t\t\t\t\tc0-0.4,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.4-0.4c-0.2-0.1-0.3-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.7,0.3l-1,0.6c-0.1,0-0.2,0-0.2,0\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3l2.1-4.6l-3.3,1.9c-0.1,0-0.2,0-0.2,0\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3l4.5-2.6c0.1,0,0.2,0,0.2,0\n\t\t\t\t\t\t\t\tc0.1,0.1,0.1,0.2,0.1,0.3v0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.4l-2,4.6c0.4-0.2,0.7-0.3,1-0.3\n\t\t\t\t\t\t\t\tc0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.4,0.2,0.8,0.2,1.4c0,0.6-0.1,1.2-0.2,1.8c-0.2,0.6-0.4,1.1-0.6,1.6\n\t\t\t\t\t\t\t\tc-0.3,0.5-0.6,0.9-0.9,1.3c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.3-1,0.5-1.3,0.5c-0.4,0-0.7,0-0.9-0.2c-0.2-0.2-0.4-0.4-0.5-0.7\n\t\t\t\t\t\t\t\tc-0.1-0.3-0.2-0.6-0.2-1c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.2l0.5-0.3c0.1,0,0.2,0,0.2,0\n\t\t\t\t\t\t\t\tC529.1,566.7,529.2,566.8,529.2,566.9z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M515.3,601.4l67.8-39.3c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-67.8,39.3\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C513.9,602.9,514.5,601.9,515.3,601.4z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M515.3,556.1l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C513.9,557.5,514.5,556.5,515.3,556.1z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M513.9,649.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l8-8.2l7.9-1l7.9-6.9l7.6-2.1l8-15.9l8,3.9\n\t\t\t\t\t\t\t\tl7.7-6.8l0.1,0l7.7-1.5l7.7-13.4c0.1-0.2,0.4-0.3,0.7-0.2c0.2,0.1,0.3,0.4,0.2,0.7l-7.9,13.7l-8,1.5l-8,7l-7.7-3.8l-7.7,15.4\n\t\t\t\t\t\t\t\tl-8,2.2l-7.9,6.9l-7.8,1l-7.7,7.9C514.1,649.5,514,649.5,513.9,649.5z",
                                          },
                                        }),
                                      ]),
                                      _c("g", { staticClass: "st707" }, [
                                        _c("path", {
                                          attrs: {
                                            d: "M513.9,649.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l8-8.2l7.9-1l7.9-6.9l7.6-2.1l8-15.9l8,3.9l7.7-6.8l0.1,0\n\t\t\t\t\t\t\t\tl7.7-1.5l7.7-13.4c0.1-0.2,0.4-0.3,0.7-0.2c0.2,0.1,0.3,0.4,0.2,0.7l-7.9,13.7l-8,1.5l-8,7l-7.7-3.8l-7.7,15.4l-8,2.2\n\t\t\t\t\t\t\t\tl-7.9,6.9l-7.8,1l-7.7,7.9C514.1,649.5,514,649.5,513.9,649.5z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M517.9,630.3c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3l-0.5,0.3c-0.1,0-0.2,0-0.2,0\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.2-0.1-0.3v-9.7l-1.9,3.3c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.2-0.1l-0.3-0.4c-0.1-0.1-0.1-0.2-0.1-0.3\n\t\t\t\t\t\t\t\tc0-0.1,0.1-0.3,0.1-0.4l2.5-4.3c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1-0.1,0.2-0.1l0.5-0.3c0.1,0,0.2,0,0.2,0\n\t\t\t\t\t\t\t\tc0.1,0.1,0.1,0.2,0.1,0.3V630.3z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M522.9,621.3c0.2-0.5,0.4-0.9,0.5-1.3c0.1-0.4,0.2-0.9,0.2-1.4c0-0.6-0.1-1.1-0.4-1.4\n\t\t\t\t\t\t\t\tc-0.2-0.3-0.6-0.3-1.1,0c-0.3,0.2-0.5,0.3-0.7,0.6c-0.2,0.2-0.3,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.3,0.9\n\t\t\t\t\t\t\t\tc-0.1,0.3-0.1,0.6-0.2,0.9c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.2l-0.5,0.3c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.2\n\t\t\t\t\t\t\t\tc0-0.4,0.1-0.9,0.2-1.4c0.1-0.5,0.3-1,0.5-1.5c0.2-0.5,0.5-1,0.8-1.4c0.3-0.4,0.7-0.8,1.1-1c0.4-0.2,0.8-0.4,1.1-0.3\n\t\t\t\t\t\t\t\tc0.3,0,0.6,0.1,0.8,0.4c0.2,0.2,0.4,0.5,0.5,0.9c0.1,0.4,0.2,0.9,0.2,1.4c0,0.4,0,0.7-0.1,1.1c0,0.3-0.1,0.7-0.2,1\n\t\t\t\t\t\t\t\tc-0.1,0.3-0.2,0.7-0.3,1c-0.1,0.3-0.3,0.7-0.5,1.1l-2.6,5.2l3.5-2c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.3v0.6\n\t\t\t\t\t\t\t\tc0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3l-5,2.9c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6\n\t\t\t\t\t\t\t\tc0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.2-0.5L522.9,621.3z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M532,614.9c0,0.5,0,1,0,1.5s0,1,0,1.5c0,0.7-0.1,1.4-0.2,2c-0.1,0.7-0.3,1.3-0.5,1.9\n\t\t\t\t\t\t\t\tc-0.2,0.6-0.5,1.1-0.9,1.5c-0.4,0.5-0.8,0.8-1.3,1.1c-0.5,0.3-0.9,0.4-1.3,0.4c-0.4,0-0.7-0.2-0.9-0.5\n\t\t\t\t\t\t\t\tc-0.2-0.3-0.4-0.7-0.5-1.2c-0.1-0.5-0.2-1.1-0.2-1.8c0-0.5,0-1,0-1.5s0-1,0-1.5c0-0.7,0.1-1.4,0.2-2c0.1-0.7,0.3-1.3,0.5-1.9\n\t\t\t\t\t\t\t\tc0.2-0.6,0.5-1.1,0.9-1.6c0.4-0.5,0.8-0.8,1.3-1.1c0.5-0.3,0.9-0.4,1.3-0.4c0.4,0,0.7,0.2,0.9,0.5c0.2,0.3,0.4,0.7,0.5,1.2\n\t\t\t\t\t\t\t\tC531.9,613.6,532,614.2,532,614.9z M527.2,620.7c0,1.1,0.2,1.8,0.5,2.2c0.3,0.4,0.8,0.4,1.4,0c0.6-0.3,1.1-0.9,1.4-1.6\n\t\t\t\t\t\t\t\tc0.3-0.7,0.5-1.6,0.5-2.8c0-0.5,0-1,0-1.5c0-0.5,0-1,0-1.5c0-1.1-0.2-1.8-0.5-2.2c-0.3-0.4-0.8-0.4-1.4,0\n\t\t\t\t\t\t\t\tc-0.6,0.3-1.1,0.9-1.4,1.6c-0.3,0.7-0.5,1.6-0.5,2.8c0,0.5,0,1,0,1.5C527.2,619.6,527.2,620.1,527.2,620.7z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M515.3,655.8l67.8-39.3c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-67.8,39.3\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C513.9,657.2,514.5,656.2,515.3,655.8z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M515.3,610.4l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C513.9,611.9,514.5,610.8,515.3,610.4z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st702",
                                          attrs: {
                                            d: "M608.1,540.7c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l7.9-6.3l7.9-9l8-1.2l7.7-1.7l7.9-9.4\n\t\t\t\t\t\t\t\tl7.8,1.4l7.8-12.4l8,0.1l7.7-6.9c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-8,7.1l-7.8-0.1l-7.9,12.5l-7.9-1.4l-7.8,9.2\n\t\t\t\t\t\t\t\tl-8,1.8l-7.7,1.1l-7.7,8.8l-7.9,6.3C608.3,540.6,608.2,540.7,608.1,540.7z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M611.2,514.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.1c0.4-0.2,0.8-0.4,1.2-0.4\n\t\t\t\t\t\t\t\tc0.4,0,0.7,0.1,0.9,0.4c0.3,0.2,0.5,0.6,0.6,1c0.1,0.4,0.2,1,0.2,1.6c0,0.6-0.1,1.2-0.2,1.8c-0.1,0.6-0.4,1.2-0.6,1.7\n\t\t\t\t\t\t\t\tc-0.3,0.5-0.6,1-0.9,1.4c-0.4,0.4-0.8,0.8-1.2,1c-0.4,0.2-0.8,0.4-1.2,0.4c-0.4,0-0.7-0.1-0.9-0.4c-0.3-0.2-0.5-0.6-0.6-1\n\t\t\t\t\t\t\t\tc-0.1-0.4-0.2-0.9-0.2-1.6c0-0.3,0-0.7,0.1-1c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.2-0.6,0.3-0.8\n\t\t\t\t\t\t\t\tl2.1-5.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2\n\t\t\t\t\t\t\t\tc0,0,0,0.1,0,0.1L611.2,514.1z M609.7,519.2c0,0.4,0,0.7,0.1,0.9c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.2,0.4,0.2,0.6,0.3\n\t\t\t\t\t\t\t\tc0.2,0,0.5-0.1,0.8-0.2c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.3-0.7,0.4-1.1c0.1-0.4,0.1-0.7,0.1-1.1\n\t\t\t\t\t\t\t\tc0-0.4,0-0.7-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.6c-0.2-0.2-0.4-0.2-0.6-0.2c-0.2,0-0.5,0.1-0.8,0.2c-0.3,0.2-0.6,0.4-0.8,0.7\n\t\t\t\t\t\t\t\tc-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.3-0.3,0.7-0.4,1.1C609.8,518.5,609.7,518.8,609.7,519.2z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M619.2,511.3c0.2-0.5,0.4-0.9,0.5-1.3c0.1-0.4,0.2-0.9,0.2-1.4c0-0.6-0.1-1.1-0.4-1.4\n\t\t\t\t\t\t\t\tc-0.2-0.3-0.6-0.3-1.1,0c-0.3,0.2-0.5,0.3-0.7,0.6c-0.2,0.2-0.3,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.3,0.9\n\t\t\t\t\t\t\t\tc-0.1,0.3-0.1,0.6-0.2,0.9c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.2l-0.5,0.3c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.2\n\t\t\t\t\t\t\t\tc0-0.4,0.1-0.9,0.2-1.4c0.1-0.5,0.3-1,0.5-1.5c0.2-0.5,0.5-1,0.8-1.4c0.3-0.4,0.7-0.8,1.1-1c0.4-0.2,0.8-0.4,1.1-0.3\n\t\t\t\t\t\t\t\tc0.3,0,0.6,0.1,0.8,0.4c0.2,0.2,0.4,0.5,0.5,0.9c0.1,0.4,0.2,0.9,0.2,1.4c0,0.4,0,0.7-0.1,1.1c0,0.3-0.1,0.7-0.2,1\n\t\t\t\t\t\t\t\tc-0.1,0.3-0.2,0.7-0.3,1c-0.1,0.3-0.3,0.7-0.5,1.1l-2.6,5.2l3.5-2c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.3v0.6\n\t\t\t\t\t\t\t\tc0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3l-5,2.9c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6\n\t\t\t\t\t\t\t\tc0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.2-0.5L619.2,511.3z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M627,500.9c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.3v0.6c0,0.1,0,0.2,0,0.4c0,0.1-0.1,0.3-0.1,0.4\n\t\t\t\t\t\t\t\tl-2.6,11.6c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3l-0.5,0.3c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.1-0.3\n\t\t\t\t\t\t\t\tc0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2l2.6-11.6l-3.8,2.2c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.3,0.1-0.4\n\t\t\t\t\t\t\t\tc0.1-0.1,0.1-0.2,0.2-0.3L627,500.9z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M609.5,546.9l67.8-39.3c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-67.8,39.3\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C608.1,548.4,608.8,547.3,609.5,546.9z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M609.5,501.5l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7S608.8,502,609.5,501.5z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st704",
                                          attrs: {
                                            d: "M608.1,595c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.3-0.4-0.2-0.7l8-13.2l8.1,1.5l7.6-2.1l7.9-9.6l7.8-2\n\t\t\t\t\t\t\t\tl7.9-14.1l8.1,2.4l7.6-1.4l7.7-6.9c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-7.9,7.1l-0.1,0l-8,1.5l-7.6-2.2l-7.8,13.8\n\t\t\t\t\t\t\t\tl-7.9,2l-7.8,9.6l-0.1,0l-8,2.2l-0.1,0l-7.5-1.4l-7.7,12.6C608.4,594.9,608.3,595,608.1,595z",
                                          },
                                        }),
                                      ]),
                                      _c("g", { staticClass: "st707" }, [
                                        _c("path", {
                                          attrs: {
                                            d: "M608.1,595c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.3-0.4-0.2-0.7l8-13.2l8.1,1.5l7.6-2.1l7.9-9.6l7.8-2l7.9-14.1l8.1,2.4\n\t\t\t\t\t\t\t\tl7.6-1.4l7.7-6.9c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-7.9,7.1l-0.1,0l-8,1.5l-7.6-2.2l-7.8,13.8l-7.9,2l-7.8,9.6\n\t\t\t\t\t\t\t\tl-0.1,0l-8,2.2l-0.1,0l-7.5-1.4l-7.7,12.6C608.4,594.9,608.3,595,608.1,595z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M611.7,572.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.1c-0.4,0.2-0.7,0.3-1.1,0.3\n\t\t\t\t\t\t\t\tc-0.3,0-0.7-0.1-0.9-0.3c-0.3-0.2-0.5-0.5-0.6-0.9c-0.2-0.4-0.2-1-0.2-1.6c0-0.6,0.1-1.2,0.2-1.8c0.2-0.6,0.4-1.2,0.6-1.7\n\t\t\t\t\t\t\t\tc0.3-0.5,0.6-1,0.9-1.4c0.3-0.4,0.7-0.7,1.1-1c0.4-0.3,0.8-0.4,1.2-0.4c0.4,0,0.7,0.1,0.9,0.4s0.4,0.6,0.6,1\n\t\t\t\t\t\t\t\tc0.1,0.4,0.2,0.9,0.2,1.5c0,0.3,0,0.6-0.1,0.9c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.2,0.7-0.3,1c-0.1,0.3-0.2,0.6-0.3,0.9\n\t\t\t\t\t\t\t\tl-2.1,5.9c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3l-0.7,0.4c-0.1,0-0.1,0-0.2,0c0-0.1-0.1-0.1-0.1-0.2\n\t\t\t\t\t\t\t\tc0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1L611.7,572.2z M613.2,567.2c0-0.4,0-0.7-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.6\n\t\t\t\t\t\t\t\tc-0.2-0.1-0.3-0.2-0.6-0.2c-0.2,0-0.5,0.1-0.7,0.2c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.3-0.4,0.5-0.6,0.9\n\t\t\t\t\t\t\t\tc-0.2,0.3-0.3,0.7-0.4,1c-0.1,0.4-0.1,0.7-0.1,1.1c0,0.4,0,0.7,0.1,1c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.1,0.3,0.2,0.6,0.2\n\t\t\t\t\t\t\t\tc0.2,0,0.5-0.1,0.7-0.2c0.3-0.1,0.5-0.4,0.7-0.6c0.2-0.3,0.4-0.5,0.6-0.9c0.2-0.3,0.3-0.7,0.4-1\n\t\t\t\t\t\t\t\tC613.2,568,613.2,567.6,613.2,567.2z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M616.2,570.9c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.3,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0\n\t\t\t\t\t\t\t\tc0.2,0,0.5-0.2,0.9-0.4c0.2-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.1-0.7,0.1-1.1\n\t\t\t\t\t\t\t\tc0-0.4,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.4-0.4c-0.2-0.1-0.3-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.7,0.3l-1,0.6c-0.1,0-0.2,0-0.2,0\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3l2.1-4.6l-3.3,1.9c-0.1,0-0.2,0-0.2,0\n\t\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3l4.5-2.6c0.1,0,0.2,0,0.2,0\n\t\t\t\t\t\t\t\tc0.1,0.1,0.1,0.2,0.1,0.3v0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.4l-2,4.6c0.4-0.2,0.7-0.3,1.1-0.3\n\t\t\t\t\t\t\t\tc0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.4,0.2,0.8,0.2,1.4c0,0.6-0.1,1.2-0.2,1.8c-0.2,0.6-0.4,1.1-0.6,1.6\n\t\t\t\t\t\t\t\tc-0.3,0.5-0.6,0.9-0.9,1.3c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.3-1,0.5-1.3,0.5c-0.4,0-0.7,0-0.9-0.2c-0.2-0.2-0.4-0.4-0.5-0.7\n\t\t\t\t\t\t\t\tc-0.1-0.3-0.2-0.6-0.2-1c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.2l0.5-0.3c0.1,0,0.2,0,0.2,0\n\t\t\t\t\t\t\t\tC616.2,570.7,616.2,570.8,616.2,570.9z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M609.5,601.2l67.8-39.3c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-67.8,39.3\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C608.1,602.7,608.8,601.7,609.5,601.2z",
                                          },
                                        }),
                                      ]),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M609.5,555.9l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C608.1,557.4,608.8,556.3,609.5,555.9z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]),
                                  _c("g", [
                                    _c("g", [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "XMLID_00000171715448927488871300000016755852840781911992_",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "XMLID_00000050647768736877917830000011115756016315312827_",
                                              },
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id: "XMLID_00000128480443285204937890000008173738891503808143_",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000134945125124822296590000012617453484956260537_",
                                                      d: "M710.2,452.4\n\t\t\t\t\t\t\t\t\t\tc3.3-1.9,6.4-2,8.9-0.7l-8.9,24.1V452.4z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000160878061321649542690000003593827935555236482_",
                                                      d: "M701.2,462.1\n\t\t\t\t\t\t\t\t\t\tc2.5-4.3,5.6-7.7,8.9-9.7v23.5L701.2,462.1z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000162344988633010506890000005327940534966527418_",
                                                      d: "M695.7,477c1-5.3,3-10.5,5.5-14.9\n\t\t\t\t\t\t\t\t\t\tl8.9,13.8L695.7,477z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st707",
                                                    attrs: {
                                                      d: "M701.2,462.1c-2.6,4.4-4.5,9.6-5.5,14.9l14.5-1.1v-23.5C706.8,454.4,703.7,457.8,701.2,462.1z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000008858587095391995300000016650367862011548056_",
                                                      d: "M719.1,451.8\n\t\t\t\t\t\t\t\t\t\tc2.6,1.4,4.5,4.3,5.5,8.5l-14.5,15.6L719.1,451.8z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000000184229558696108770000006743288702958515358_",
                                                      d: "M695.7,491.5\n\t\t\t\t\t\t\t\t\t\tc-0.5-2-0.7-4.3-0.7-6.8c0-2.5,0.3-5.1,0.7-7.7l14.5-1.1L695.7,491.5z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000115487986007702887130000005691016456329780368_",
                                                      d: "M724.7,474.8\n\t\t\t\t\t\t\t\t\t\tc-1,5.3-3,10.5-5.5,14.9l-8.9-13.8L724.7,474.8z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000107564248386862012940000010470765539112299183_",
                                                      d: "M710.2,499.4\n\t\t\t\t\t\t\t\t\t\tc-3.3,1.9-6.4,2-8.9,0.7l8.9-24.1V499.4z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000172439280404129736720000015859720207444335009_",
                                                      d: "M695.7,491.5l14.5-15.6l-8.9,24.1\n\t\t\t\t\t\t\t\t\t\tC698.6,498.6,696.7,495.7,695.7,491.5z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000049200271636171200030000005953279509472527522_",
                                                      d: "M724.7,460.3\n\t\t\t\t\t\t\t\t\t\tc0.5,2,0.7,4.3,0.7,6.8c0,2.5-0.3,5.1-0.7,7.7l-14.5,1.1L724.7,460.3z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000055699388702538029340000009946710495301125557_",
                                                      d: "M719.1,489.7\n\t\t\t\t\t\t\t\t\t\tc-2.5,4.3-5.6,7.7-8.9,9.7v-23.5L719.1,489.7z",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M702.6,511.3l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-15.2,8.8c-0.8,0.4-1.4,0.1-1.4-0.7\n\t\t\t\t\t\t\t\tC701.2,512.8,701.8,511.8,702.6,511.3z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M699.2,522.4l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-21.9,12.7\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C697.8,523.8,698.4,522.8,699.2,522.4z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M699.2,531.4l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-21.9,12.7\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C697.8,532.9,698.4,531.9,699.2,531.4z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M699.2,540.5l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-21.9,12.7\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C697.8,542,698.4,541,699.2,540.5z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _c("g", [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "XMLID_00000071532111392644019450000004361671073668143005_",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "XMLID_00000026856415536110031660000013530390095282445451_",
                                              },
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id: "XMLID_00000018221669484121832310000002808444600002141864_",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000143617521604918258260000007303595142050411455_",
                                                      d: "M765.1,420.6\n\t\t\t\t\t\t\t\t\t\tc3.3-1.9,6.4-2,8.9-0.7l-8.9,24.1V420.6z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000088813138016767377010000017457665404543660184_",
                                                      d: "M756.2,430.3\n\t\t\t\t\t\t\t\t\t\tc2.5-4.3,5.6-7.7,8.9-9.7v23.5L756.2,430.3z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000132055433379871220920000005346629718066114482_",
                                                      d: "M750.6,445.2\n\t\t\t\t\t\t\t\t\t\tc1-5.3,3-10.5,5.5-14.9l8.9,13.8L750.6,445.2z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000163043715744964712980000010215212315953261498_",
                                                      d: "M774.1,419.9\n\t\t\t\t\t\t\t\t\t\tc2.6,1.4,4.5,4.3,5.5,8.5l-14.5,15.6L774.1,419.9z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000150814861355898096730000007226763260526139046_",
                                                      d: "M750.6,459.7\n\t\t\t\t\t\t\t\t\t\tc-0.5-2-0.7-4.3-0.7-6.8c0-2.5,0.3-5.1,0.7-7.7l14.5-1.1L750.6,459.7z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000038377266033459602370000004162581052014154910_",
                                                      d: "M779.6,442.9\n\t\t\t\t\t\t\t\t\t\tc-1,5.3-3,10.5-5.5,14.9l-8.9-13.8L779.6,442.9z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000026850739906559917830000012058698411113521826_",
                                                      d: "M765.1,467.5\n\t\t\t\t\t\t\t\t\t\tc-3.3,1.9-6.4,2-8.9,0.7l8.9-24.1V467.5z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000020373423992632858310000014232455436360460171_",
                                                      d: "M750.6,459.7l14.5-15.6l-8.9,24.1\n\t\t\t\t\t\t\t\t\t\tC753.6,466.8,751.6,463.8,750.6,459.7z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st707",
                                                    attrs: {
                                                      d: "M756.2,430.3c-2.6,4.4-4.5,9.6-5.5,14.9c-0.5,2.6-0.7,5.2-0.7,7.7c0,2.5,0.3,4.8,0.7,6.8\n\t\t\t\t\t\t\t\t\t\tc1,4.2,3,7.1,5.5,8.5l8.9-24.1v-23.5C761.8,422.5,758.7,426,756.2,430.3z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000096057045127280664680000017872093713379500219_",
                                                      d: "M779.6,428.4\n\t\t\t\t\t\t\t\t\t\tc0.5,2,0.7,4.3,0.7,6.8s-0.3,5.1-0.7,7.7l-14.5,1.1L779.6,428.4z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    staticClass: "st704",
                                                    attrs: {
                                                      id: "XMLID_00000049199312788545023290000014634106171240222136_",
                                                      d: "M774.1,457.8\n\t\t\t\t\t\t\t\t\t\tc-2.5,4.3-5.6,7.7-8.9,9.7v-23.5L774.1,457.8z",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("g", [
                                        _c("path", {
                                          staticClass: "st706",
                                          attrs: {
                                            d: "M757.5,479.6l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-15.2,8.8c-0.8,0.4-1.4,0.1-1.4-0.7\n\t\t\t\t\t\t\t\tC756.1,481.1,756.8,480,757.5,479.6z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M754.2,490.6l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-21.9,12.7\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C752.8,492.1,753.4,491.1,754.2,490.6z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M754.2,499.7l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-21.9,12.7\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C752.8,501.2,753.4,500.2,754.2,499.7z",
                                          },
                                        }),
                                        _c("path", {
                                          staticClass: "st662",
                                          attrs: {
                                            d: "M754.2,508.8l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-21.9,12.7\n\t\t\t\t\t\t\t\tc-0.8,0.4-1.4,0.1-1.4-0.7C752.8,510.3,753.4,509.2,754.2,508.8z",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Price Watcher")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }